module.exports = __webpack_public_path__ + "static/img/game-series-128.86aeb96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game/game-series-128.png
// module id = BEAU
// module chunks = 1